import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const RadioPlayerContainer = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: ${({ theme }) => theme.Surface.primary};
    display: grid;
    grid-template-columns: 48px 1fr 16px;
    place-items: center;
    padding: 12px;
    ${({ theme }) => BaseStyle.Mixins.utility.boxShadow(8, theme.Surface.shim, [BaseStyle.StyleDirections.up])}
    clip-path: none;

    ${BaseStyle.Mixins.screenSizes.medium} {
        width: fit-content;
        clip-path: unset;
        left: unset;
        right: 24px;
        bottom: 24px;
        border-radius: 4px;
        box-shadow: ${BaseStyle.Mixins.utility.fadedBoxShadow};
    }
`;

export const RadioPlayerPlayButton = styled.div`
    height: 48px;
    width: 48px;
    cursor: pointer;

    svg {
        height: 100%;
        width: 100%;
        fill: ${({ theme }) => theme.Utility.cta};
    }
`;

export const RadioPlayerPicker = styled.div`
    ${BaseStyle.Mixins.gaps.small}
    display: flex;
    flex-direction: column;
`;

export const PickerLabel = styled.label`
    color: ${({ theme }) => theme.Text.secondary};
    ${BaseStyle.Mixins.fontStyles.ui['12m']}
`;

export const RadioPlayerCloseButton = styled.div`
    height: 100%;
    place-self: start;
    cursor: pointer;

    svg {
        height: 20px;
        width: 20px;
    }
`;
